export const cacheTime = process.env.NEXT_PUBLIC_CACHE_TIME
  ? parseInt(process.env.NEXT_PUBLIC_CACHE_TIME)
  : undefined;
